import { demo } from './demo.ts'
import { denmark as DK } from './denmark.ts'
import { finland as FI } from './finland.ts'
import { norway as NO } from './norway.ts'
import { sweden as SE } from './sweden.ts'

// export as 2 character ISO 3166 country code
export default {
  demo,
  DK,
  FI,
  NO,
  SE
}
